import { ENGINE_MATCHER_GREATER } from '../../logger/constants';
export function greaterThanEqualMatcherContext(log, ruleAttr) {
    return function greaterThanEqualMatcher(runtimeAttr) {
        var isGreaterEqualThan = runtimeAttr >= ruleAttr;
        log.debug(ENGINE_MATCHER_GREATER, [runtimeAttr, ruleAttr, isGreaterEqualThan]);
        return isGreaterEqualThan;
    };
}
